export default __webpack_public_path__ + "static/slide-4-07c9e32d4bd92ac88f13c2e1ee897e3c.jpg";